var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{class:`overflow-scroll h-[calc(100%-70px)]  !bg-black !relative`,attrs:{"dark":""}},[(_vm.transactionLoading)?_c('LoadingSpinner',{staticClass:"h-full w-full"}):_vm._e(),(!_vm.transactions)?_c('div',{directives:[{name:"motion",rawName:"v-motion"}],class:`h-[10vh] bg-black flex items-center justify-center text-xl ${_vm.routeLink}-border font-Nunito border-[1px] rounded-md`,attrs:{"initial":{
            y: 100,
            opacity: 0,
        },"enter":{
    y: 0,
    opacity: 1,
    transition: {
        duration: 300,
        type: 'keyframes',
        ease: 'easeInOut',
        delay: `100`
    },
}}},[_vm._v(" No Trasaction History ")]):_vm._l((_vm.transactions),function(item,idx){return _c('v-list-item',{directives:[{name:"motion",rawName:"v-motion"}],key:item.id,class:`!border-[1px] py-2 ${_vm.routeLink}-border font-Nunito text-sm rounded-md my-2`,attrs:{"initial":{
                y: 100,
                opacity: 0,
            },"enter":{
    y: 0,
    opacity: 1,
    transition: {
        duration: 300,
        type: 'keyframes',
        ease: 'easeInOut',
        delay: `${idx}00`
    },
}}},[_c('div',{staticClass:"!flex items-center justify-between w-full gap-2"},[_c('div',{staticClass:"bg-gray-700 rounded-lg"},[_c('div',{class:`flex flex-col bg-white !grow-0  rounded-lg p-2 text-center ${_vm.routeLink}_fortext`},[_c('div',{},[_vm._v(_vm._s(item.month))]),_c('div',{},[_vm._v(_vm._s(item.year))])])]),_c('div',{staticClass:"text-sm whitespace-nowrap overflow-hidden text-ellipsis"},[_vm._v(" "+_vm._s(item.invoice_number)+" ")]),_c('div',{staticClass:"text-sm whitespace-nowrap"},[_vm._v(" $ "+_vm._s(item.amount)+" ")]),_c('div',{staticClass:"!grow-0"},[_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){$event.preventDefault();return _vm.showReceiptHandler(item)}}},[_c('v-icon',{class:`!text-3xl`,attrs:{"color":_vm.colorAsRoute}},[_vm._v(" mdi-arrow-right-circle-outline ")])],1)],1)])])}),_c('TransactionReceipt',{attrs:{"showReceipt":_vm.showReceipt,"receiptData":_vm.currentActiveReceipt},on:{"closeReceipt":function($event){_vm.showReceipt = false}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }